<template>
  <label
    class="checkbox"
    :class="$attrs.class"
  >
    <input
      :id="name"
      v-bind="{ ...$attrs, class: '', trueValue, falseValue }"
      type="checkbox"
      :name="name"
      :checked="value"
      :value="+(value | 0)"
      :required="required"
      class="checkbox__field p-absolute opacity-0"
      @input="$e => setValue($e.target.checked)"
    >

    <span
      class="checkbox__switch d-block w-100 h-100 p-relative"
      :class="{ 'checkbox__switch--checked': modelValue }"
    />
  </label>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CheckBox',

  inheritAttrs: false,

  props: {
    modelValue: {
      type: [Boolean, Number],
      default: () => false
    },

    name: {
      type: String,
      default: ''
    },

    trueValue: {
      type: [String, Number, Boolean],
      default: () => true
    },

    falseValue: {
      type: [String, Number, Boolean],
      default: () => false
    },

    required: Boolean
  },

  emits: ['update:modelValue', 'input'],

  computed: {
    value: {
      get () {
        return !!this.modelValue
      },

      set (v) {
        this.$emit('input', v)
        this.$emit('update:modelValue', v)
      }
    }
  },

  methods: {
    setValue (v) {
      this.value = v
    }
  }
})
</script>

<style lang="scss" scoped>
  .checkbox {
    --stroke: rgb(var(--white));
    --fillColor: rgb(var(--primary-rgb));

    width: 18px;
    height: 18px;
    background-color: transparent;

    &__field {
      width: 1px;
      height: 1px;
    }

    &__switch {
      border-radius: 4px;
      transition: .2s ease-in-out;
      background-color: transparent;
      border: solid 2px var(--fillColor);

      &--checked {
        background-color: var(--fillColor);
      }

      input:checked + &:after {
        opacity: 1;
      }

      &:after {
        content: '';

        top: 50%;
        left: 50%;
        opacity: 0;
        position: absolute;

        width: 5px;
        height: 10px;
        border: solid var(--stroke);
        border-width: 0 2px 2px 0;
        transform: translate(-50%, -60%) rotate(45deg);
      }
    }
  }
</style>
